/*
 * @Author: wangbaihe
 * @Date: 2025-10-31 19:23:14
 * @LastEditors: wangbaihe
 * @LastEditTime: 2026-02-04 09:31:40
 * @FilePath: \common-mediax\src\apis\MediaCloudWire\Table.js
 * @Description:
 */
import { createAPI } from '../../common'

// MediaCloundWireTable
export default {
  // // 稿件知识属性分类接口
  // WireCateGory: (config, vconfig = { neverLoading: false }) =>
  //   createAPI('customEncryptApiName-1/0nfejby.tztufn0xjsf0dbufhpsz', 'get', config, vconfig),
  // 新华社稿件删除接口
  articleDelete: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf', 'delete', config, vconfig),
  // 新华社稿件选用接口
  articleSelect: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0tfmfdu', 'post', config, vconfig),
  // 新华社图片选用接口
  articlePhotoSelect: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0qipup0tfmfdu', 'post', config, vconfig),
  // 新华社稿件下载接口
  articleDownload: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0epxompbe', 'get', config, vconfig),
  //新华社稿件送稿接口
  articleSend: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0tfoe', 'post', config, vconfig),
  // 新华和稿件详情接口
  articleDetail: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0efubjm', 'get', config, vconfig),
  //新华社稿件流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0f60bdujpot0mpht', 'get', config, vconfig),
  //新华社稿件 新华社图片签发报纸
  postPaperArticlesForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmft0qbqfst0gpsxbse', 'post', config, {
      ...vconfig,
      timeout: 90000
    }),
  //新华社稿件 新华社图片三方渠道
  postArticlesForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 新华社图片删除接口
  photoDelete: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0qipup', 'delete', config, vconfig),
  // 新华社图片选用接口
  photoSelect: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0qipup0tfmfdu', 'post', config, vconfig),
  // 新华社图片下载接口
  photoDownload: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0qipup0epxompbe', 'get', config, vconfig),
  // 新华社图片送稿接口
  photoSend: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0qipup0tfoe', 'post', config, vconfig),
  // 新华社图片详情接口
  photoDetail: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0qipup0efubjm', 'get', config, vconfig),
  //新华社右键菜单preaction接口
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  //新华社右键菜单postAction接口
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 列表下载
  putDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0epxompbe', 'post', config, {
      timeout: 86400000
    }),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0f60bdujpot0efubjmbdujpot', 'get', config),

  // 打印
  putPrint: (config) => createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0qsjou', 'put', config),
  // 新华社稿件删除接口
  wireDelete: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0sttdgh', 'delete', config, vconfig),
  // 采编选用查记录
  getSelectedDocs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0hfuTfmfdufeEpdt', 'get', config, {
      neverLoading: true
    }),
  // 收藏
  postArticleCollect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0dpmmfdu', 'POST', config)
}
